export const Types = {
    SAVE_LIST_BUSINESS_VOUCHER: 'SAVE_LIST_BUSINESS_VOUCHER',
    SAVE_LIST_BUSINESS_VOUCHER_SUB : 'SAVE_LIST_BUSINESS_VOUCHER_SUB'
}
